import React from 'react'

import { Info, Switch, Tooltip, TypeStyle } from '@syconium/little-miss-figgy'

import {
  PreferenceLabel,
  PreferenceToggleContainer,
  PreferenceTooltipButtonWrapper,
} from './shared-form-styles'

interface PreferencesToggleProps {
  checked: boolean
  onToggle: () => void
  switchLabel: string
  tooltipText: string
  tooltipAriaLabel: string
}

export const PreferencesToggle: React.FC<PreferencesToggleProps> = ({
  checked,
  onToggle,
  switchLabel,
  tooltipText,
  tooltipAriaLabel,
}) => {
  return (
    <PreferenceToggleContainer>
      <Switch aria-label={switchLabel} checked={checked} size='small' onChange={onToggle}></Switch>
      <PreferenceLabel>{switchLabel}</PreferenceLabel>
      <Tooltip content={<TypeStyle.BodyDefault>{tooltipText}</TypeStyle.BodyDefault>}>
        <PreferenceTooltipButtonWrapper type='button' aria-label={tooltipAriaLabel}>
          <Info />
        </PreferenceTooltipButtonWrapper>
      </Tooltip>
    </PreferenceToggleContainer>
  )
}
